import React, { useState, useEffect, useRef } from "react";
import DefaultLayout from '../components/DefaultLayout';
import axios from 'axios';
import { Row, Col, Menu } from 'antd';
import config from "../config";
import { io } from 'socket.io-client';
import Receipt from "../components/Receipt";
import demoVid from "../assets/video/demoVid.mp4"
import { Modal } from "antd";
import CustomerReceipt from "../components/CustomerReceipt";
import { FileUnknownOutlined } from '@ant-design/icons';

const ReceiptDisplay = () => {
    const [receipt, setReceipt] = useState([]);
    const isElectron = window && window.process && window.process.type;
    const apiBaseUrl = isElectron
        ? "http://localhost:8080" // backend in dev or packaged mode
        : process.env.REACT_APP_API_URL || "http://localhost:8080";
    const [receiptDisplay, setReceiptDisplay] = useState(false);
    const [pax, setPax] = useState('');
    const [service, setService] = useState([]);
    const [takeAwayTable, setTakeAwayTable] = useState(false);
    const [tableNo, setTableNo] = useState('');
    const [paymentData, setPaymentData] = useState([]);
    const [orderInvoiceId, setOrderInvoiceId] = useState("");
    const receiptRef = useRef();
    const videoRef = useRef(null);
    const [videoList, setVideoList] = useState([]);
    const videoARef = useRef(null);
    const [socketConnected, setSocketConnected] = useState(false);


    const fetchVideoList = () => {
        fetch(`${apiBaseUrl}/api/videos`)
            .then(res => res.json())
            .then(data => {
                setVideoList(data);
            })
            .catch(err => {
                console.error('Error fetching videos:', err);
            });
    };

    // Add refs to track latest state
    const receiptDisplayRef = useRef(receiptDisplay);
    const paymentDataRef = useRef(paymentData);
    useEffect(() => {
        receiptDisplayRef.current = receiptDisplay;
        paymentDataRef.current = paymentData;
    }, [receiptDisplay, paymentData]);

    useEffect(() => {
        if (videoList.length === 0 && videoARef.current) {
            videoARef.current.pause();
            videoARef.current.removeAttribute('src');
            videoARef.current.load();
        }
    }, [videoList]);


    useEffect(() => {

        let userId = localStorage.getItem('userId');

        // If no userId is set, try to get it from URL parameters (for second display)
        if (!userId) {
            const urlParams = new URLSearchParams(window.location.search);
            userId = urlParams.get('userId');
            if (userId) {
                localStorage.setItem('userId', userId);
            }
        }

        console.log('ReceiptDisplay userId:', userId);

        fetchVideoList();
        let socketUrl;
        try {
            socketUrl = apiBaseUrl;
        } catch {
            socketUrl = apiBaseUrl;
        }

        const socket = io(socketUrl, {
            query: {
                userId: userId,
            }
        });

        socket.on('connect', () => {
            console.log('ReceiptDisplay connected to socket with userId:', userId);
            setSocketConnected(true);
        });

        socket.on('disconnect', () => {
            console.log('ReceiptDisplay disconnected from socket');
            setSocketConnected(false);
        });

        socket.on('videoListUpdate', () => {
            setVideoList([]);
            fetchVideoList();
        });


        socket.on('newPayment', ({ receipt, paymentData }) => {
            setOrderInvoiceId(paymentData.newestInvoiceId);
            setReceipt(receipt);
            setPax(receipt.pax);
            setService(receipt.billAmount.services);
            setTakeAwayTable(receipt.takeAway);
            setTableNo(receipt.tableNo);
            setReceiptDisplay(true);
            setPaymentData(paymentData);
        });

        // Listen for previewReceipt event
        socket.on('previewReceipt', ({ paymentData: previewData, tableNumber, pax, services, takeAwayTable }) => {
            // If a final receipt is being displayed, ignore previewReceipt events
            if (receiptDisplayRef.current && !(paymentDataRef.current && paymentDataRef.current.isPreview)) {
                return;
            }
            setOrderInvoiceId(null); // No invoice for preview
            setReceipt([]); // No receipt object for preview
            setPax(pax);
            setService(services);
            setTakeAwayTable(takeAwayTable);
            setTableNo(tableNumber);
            setReceiptDisplay(true);
            setPaymentData(previewData);
        });

        // Listen for closePreviewReceipt event
        socket.on('closePreviewReceipt', () => {
            console.log('ReceiptDisplay: closePreviewReceipt received');
            setReceiptDisplay(false);
        });

        return () => socket.disconnect();
    }, []);

    useEffect(() => {
        let timer;
        // Only set timer for final receipts (not preview)
        if (receiptDisplay && !(paymentData && paymentData.isPreview)) {
            videoRef.current?.pause();
            timer = setTimeout(() => {
                setReceiptDisplay(false);
            }, 15000); // 15 seconds for final receipts
        }
        return () => {
            clearTimeout(timer);
        };
    }, [receiptDisplay, paymentData]);


    return (
        <>
            {receiptDisplay && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 9998,
                    pointerEvents: 'auto'
                }}>
                    <CustomerReceipt
                        ref={receiptRef}
                        // orders={receipt}
                        invoiceId={orderInvoiceId}
                        tableNumber={tableNo}
                        pax={pax}
                        services={service}
                        takeAwayTable={takeAwayTable}
                        paymentData={paymentData}
                    />
                </div>
            )}

            <video
                ref={videoARef}
                muted
                autoPlay
                loop
                controls={false}
                preload="auto"
                src={videoList.length > 0 ? `${apiBaseUrl}${videoList[0]}` : undefined}
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    zIndex: -2,
                    transition: 'opacity 1s ease-in-out',
                    opacity: receiptDisplay ? 0.1 : 1, // Make video more transparent when receipt is shown
                    pointerEvents: receiptDisplay ? 'none' : 'auto', // Disable video interaction when receipt is shown
                }}
            />


            {videoList.length === 0 && (
                <div
                    style={{
                        textAlign: 'center',
                        padding: '60px 20px',
                        backgroundColor: '#fff7e6',
                        border: '1px solid #ffd591',
                        borderRadius: '12px',
                        marginTop: '20px',
                    }}
                >
                    <FileUnknownOutlined style={{ fontSize: 64, color: '#fa8c16' }} />
                    <h3 style={{ color: '#fa8c16', marginTop: '20px' }}>No Videos Found</h3>
                    <p style={{ color: '#8c8c8c' }}>Upload a video to get started.</p>
                </div>
            )}
        </>

    );
}

export default ReceiptDisplay;